// @flow

import { useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { ApiContext } from "../../../context/KeaAPI/newApi";
import { SchemaTree } from "../../../types/SchemaTree";
import { GradingService } from "../../../types/GradingService";

type Props = {
  gradingService: GradingService | undefined;
  schemaTree: SchemaTree | undefined;
  closeAction: () => void;
  visible: boolean;
};

export const TreeViewEditGradingServiceComponent = (props: Props) => {
  const { t } = useTranslation();
  const { schemaTreeApi } = useContext(ApiContext);

  const schemaTree = props.schemaTree;
  if (!schemaTree)
    throw Error(
      `Unknown schema tree edge in TreeViewEditGradingServiceComponent for grading service ${props.gradingService}.`,
    );

  // schema and schemaTree can be used to reset.
  const [workingSchemaTree, setWorkingSchemaTree] = useState<SchemaTree | undefined>(schemaTree);

  const handleWeightChange = (event: any) => {
    if (!workingSchemaTree) return;
    setWorkingSchemaTree({ ...workingSchemaTree, [event.target.name]: parseInt(event.target.value, 10) });
  };

  const update = () => {
    // only allow updating the weight
    if (schemaTree && workingSchemaTree) {
      let schemaTreeToUpdate: SchemaTree = { ...schemaTree, weight: workingSchemaTree.weight };
      schemaTreeApi.update(schemaTreeToUpdate);
    }
  };

  // reset the form every time this component is shown
  useEffect(() => {
    if (props.visible) reset();
  }, [props.visible]);

  const reset = () => setWorkingSchemaTree(schemaTree);

  return (
    <div className="container mt-6" style={{ display: props.visible ? undefined : "none" }}>
      <div className="section">
        <div className="columns is-centered">
          <div className="column is-three-quarters">
            <div className="box">
              <h4 className="title is-4">{t("schema")}</h4>
              {!workingSchemaTree ? (
                <></>
              ) : (
                <div className="field">
                  <label className="label">{t("weight")}</label>
                  <input
                    className="input"
                    type="text"
                    name="weight"
                    value={workingSchemaTree.weight ?? ""}
                    onChange={handleWeightChange}
                  />
                </div>
              )}
              <div className="columns mt-5">
                <button
                  className="button is-danger"
                  onClick={() => {
                    reset();
                    props.closeAction();
                  }}
                >
                  {t("cancel")}
                </button>
                <button
                  className="button is-normal is-success"
                  onClick={() => {
                    update();
                    props.closeAction();
                  }}
                >
                  {t("save")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
